function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UseCasesService from '@/apps/attributes/services/use_cases_service';
import tasks from '@/js/tasks';
var NON_RETRYABLE_STATUS_STEPS = ['aws_pipeline', 'duplicate_attribute_validation'];
var DUPLICATE_VALIDATION_STEP = 'duplicate_attribute_validation';
var DUPLICATE_GROUP_KEYS = ['duplicates_by_category', 'duplicate_by_category', 'duplicated_by_category', 'duplicates_by_column', 'attributes_by_category', 'duplicate_categories_detail'];
var DUPLICATE_ATTRIBUTE_KEYS = ['duplicated_attributes', 'duplicate_attributes', 'duplicates', 'existing_attributes', 'attributes', 'items', 'records'];
var DUPLICATE_CATEGORY_KEYS = ['duplicated_categories', 'duplicate_categories', 'categories'];
var DUPLICATE_NESTED_KEYS = ['data', 'detail_data', 'metadata', 'result', 'payload', 'technical_detail', 'validation', 'duplicate_validation', 'duplicateAttributeValidation', 'response', 'error'];
var DUPLICATE_DETAIL_KEYS = ['detail', 'details'];
var ATTRIBUTE_NAME_KEYS = ['attribute_name', 'attribute', 'atributo', 'nombre', 'name', 'column_name', 'column', 'field_name', 'field'];
var CATEGORY_NAME_KEYS = ['attribute_category', 'category', 'categoria', 'category_name', 'attributeCategory'];
export default {
  name: 'ActivityTimelineDialog',
  data: function data() {
    return {
      isIntercorpAdminUser: false,
      visible: false,
      loading: false,
      error: null,
      automationId: null,
      automationItem: null,
      recordStatusId: null,
      executions: [],
      pagination: {
        page: 1,
        page_size: 10,
        total: 0
      },
      expandedSet: new Set(),
      retryingExec: null,
      retryingStep: null,
      bulkRetryActive: false
    };
  },
  computed: {
    canLoadMore: function canLoadMore() {
      return this.executions.length < this.pagination.total;
    },
    isAdmin: function isAdmin() {
      var roles = window.userInfo && window.userInfo.userRoles || [];
      return roles.includes('attribute_admin');
    },
    canRetryAll: function canRetryAll() {
      return this.isIntercorpAdminUser;
    },
    recordStatusText: function recordStatusText() {
      var statusId = Number(this.recordStatusId);
      var map = {
        1: this.$t('create_attribute.status.solicitado'),
        2: this.$t('create_attribute.status.error'),
        12: this.$t('create_attribute.status.en_ejecucion'),
        14: this.$t('create_attribute.status.ejecutado'),
        21: this.$t('create_attribute.status.inactive'),
        23: this.$t('create_attribute.status.processing')
      };
      return map[statusId] || this.recordStatusId;
    },
    recordStatusColor: function recordStatusColor() {
      var statusId = Number(this.recordStatusId);
      var map = {
        1: 'warning',
        2: 'error',
        12: 'info',
        14: 'success',
        21: 'grey',
        23: 'warning'
      };
      return map[statusId] || 'grey';
    }
  },
  methods: {
    open: function open(item) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$focusActive = _ref.focusActive,
        focusActive = _ref$focusActive === void 0 ? false : _ref$focusActive,
        _ref$isIntercorpAdmin = _ref.isIntercorpAdmin,
        isIntercorpAdmin = _ref$isIntercorpAdmin === void 0 ? false : _ref$isIntercorpAdmin;
      this.isIntercorpAdminUser = isIntercorpAdmin;
      this.automationItem = item;
      this.automationId = item.automate_id;
      this.recordStatusId = item.status_id || item.estado || null;
      this.executions = [];
      this.pagination = {
        page: 1,
        page_size: 10,
        total: 0
      };
      this.expandedSet = new Set();
      this.error = null;
      this.visible = true;
      this.fetchPage({
        replace: true,
        focusActive: focusActive
      });
    },
    close: function close() {
      if (this.bulkRetryActive) return;
      this.visible = false;
    },
    refresh: function refresh() {
      this.pagination.page = 1;
      this.fetchPage({
        replace: true
      });
    },
    loadMore: function loadMore() {
      this.pagination.page += 1;
      this.fetchPage({
        replace: false
      });
    },
    fetchPage: function () {
      var _fetchPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _ref2,
          _ref2$replace,
          replace,
          _ref2$silent,
          silent,
          _ref2$focusActive,
          focusActive,
          response,
          data,
          newExecs,
          active,
          target,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$replace = _ref2.replace, replace = _ref2$replace === void 0 ? true : _ref2$replace, _ref2$silent = _ref2.silent, silent = _ref2$silent === void 0 ? false : _ref2$silent, _ref2$focusActive = _ref2.focusActive, focusActive = _ref2$focusActive === void 0 ? false : _ref2$focusActive;
              if (this.automationId) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!silent) this.loading = true;
              this.error = null;
              _context.p = 2;
              _context.n = 3;
              return UseCasesService.getActivityTimeline(this.automationId, {
                page: this.pagination.page,
                page_size: this.pagination.page_size
              });
            case 3:
              response = _context.v;
              if (response && response.success) {
                data = response.data || {};
                newExecs = data.executions || [];
                this.recordStatusId = data.record_status_id || this.recordStatusId;
                this.executions = replace ? newExecs : [].concat(_toConsumableArray(this.executions), _toConsumableArray(newExecs));
                this.pagination = data.pagination || this.pagination;
                if (replace) {
                  active = newExecs.find(function (e) {
                    return e.is_active;
                  });
                  target = focusActive && active ? active : newExecs[0];
                  if (target && !this.expandedSet.has(target.execution_id)) {
                    this.expandedSet = new Set([target.execution_id]);
                  }
                }
              } else if (!silent) {
                this.error = response && response.message || 'Error al obtener actividad';
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              if (!silent) this.error = _t.message || 'Error de conexión';
            case 5:
              _context.p = 5;
              if (!silent) this.loading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function fetchPage() {
        return _fetchPage.apply(this, arguments);
      }
      return fetchPage;
    }(),
    toggleExecution: function toggleExecution(id) {
      var next = new Set(this.expandedSet);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      this.expandedSet = next;
    },
    isExpanded: function isExpanded(id) {
      return this.expandedSet.has(id);
    },
    stepDetailText: function stepDetailText(step) {
      var detail = this.parseMaybeJson(step && step.detail);
      if (!detail) return '';
      if (typeof detail === 'string') return this.translateTechnicalDetail(detail);
      return this.pickFirstText(detail, ['message', 'detail', 'description', 'error']);
    },
    translateTechnicalDetail: function translateTechnicalDetail(detail) {
      var match = String(detail || '').match(/^hist_status_execution=(\d+)$/);
      if (!match) return detail;
      var statusId = Number(match[1]);
      var map = {
        1: this.$t('create_attribute.status.solicitado'),
        2: this.$t('create_attribute.status.error'),
        12: this.$t('create_attribute.status.en_ejecucion'),
        14: this.$t('create_attribute.status.ejecutado'),
        21: this.$t('create_attribute.status.inactive'),
        23: this.$t('create_attribute.status.processing')
      };
      return "Estado de ejecucion AWS: ".concat(map[statusId] || statusId);
    },
    duplicateGroups: function duplicateGroups(step) {
      var _this = this;
      if (!step || step.step !== DUPLICATE_VALIDATION_STEP) return [];
      var entries = [];
      this.collectDuplicateEntries(step, entries);
      var grouped = new Map();
      entries.forEach(function (entry) {
        var category = _this.cleanDuplicateText(entry.category) || 'Sin categoria';
        var attribute = _this.cleanDuplicateText(entry.attribute);
        if (!grouped.has(category)) grouped.set(category, new Set());
        if (attribute) grouped.get(category).add(attribute);
      });
      return Array.from(grouped.keys()).sort(function (a, b) {
        return a.localeCompare(b);
      }).map(function (category) {
        return {
          category: category,
          attributes: Array.from(grouped.get(category)).sort(function (a, b) {
            return a.localeCompare(b);
          })
        };
      });
    },
    collectDuplicateEntries: function collectDuplicateEntries(value, entries) {
      var _this2 = this;
      var parentCategory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var parsed = this.parseMaybeJson(value);
      if (!parsed) return;
      if (typeof parsed === 'string') {
        this.pushDuplicateEntry(entries, parentCategory, parsed);
        return;
      }
      if (Array.isArray(parsed)) {
        parsed.forEach(function (item) {
          return _this2.collectDuplicateEntries(item, entries, parentCategory);
        });
        return;
      }
      if (_typeof(parsed) !== 'object') return;
      var ownCategory = this.pickFirstText(parsed, CATEGORY_NAME_KEYS) || parentCategory;
      var ownAttribute = this.pickFirstText(parsed, ATTRIBUTE_NAME_KEYS);
      if (ownAttribute && Array.isArray(parsed.matches)) {
        parsed.matches.forEach(function (match) {
          var matchCategory = _this2.pickFirstText(match, CATEGORY_NAME_KEYS) || ownCategory;
          _this2.pushDuplicateEntry(entries, matchCategory, ownAttribute);
        });
        return;
      }
      if (ownCategory || ownAttribute) {
        this.pushDuplicateEntry(entries, ownCategory, ownAttribute);
      }
      DUPLICATE_GROUP_KEYS.forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(parsed, key)) {
          _this2.collectDuplicateCategoryMap(parsed[key], entries);
        }
      });
      DUPLICATE_ATTRIBUTE_KEYS.forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(parsed, key)) {
          _this2.collectDuplicateEntries(parsed[key], entries, ownCategory);
        }
      });
      DUPLICATE_CATEGORY_KEYS.forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(parsed, key)) {
          _this2.collectDuplicateCategoryList(parsed[key], entries);
        }
      });
      DUPLICATE_NESTED_KEYS.forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(parsed, key)) return;
        var nested = _this2.parseMaybeJson(parsed[key]);
        if (nested && typeof nested !== 'string') {
          _this2.collectDuplicateEntries(nested, entries, ownCategory);
        }
      });
      DUPLICATE_DETAIL_KEYS.forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(parsed, key)) return;
        var detail = _this2.parseMaybeJson(parsed[key]);
        if (detail && typeof detail !== 'string') {
          _this2.collectDuplicateEntries(detail, entries, ownCategory);
        }
      });
    },
    collectDuplicateCategoryMap: function collectDuplicateCategoryMap(value, entries) {
      var _this3 = this;
      var parsed = this.parseMaybeJson(value);
      if (!parsed) return;
      if (Array.isArray(parsed)) {
        parsed.forEach(function (item) {
          var category = _this3.pickFirstText(item, CATEGORY_NAME_KEYS);
          _this3.collectDuplicateEntries(item, entries, category);
        });
        return;
      }
      if (_typeof(parsed) !== 'object') return;
      Object.keys(parsed).forEach(function (category) {
        var children = parsed[category];
        var before = entries.length;
        _this3.collectDuplicateEntries(children, entries, category);
        if (entries.length === before) {
          _this3.pushDuplicateEntry(entries, category, '');
        }
      });
    },
    collectDuplicateCategoryList: function collectDuplicateCategoryList(value, entries) {
      var _this4 = this;
      var parsed = this.parseMaybeJson(value);
      if (!parsed) return;
      if (Array.isArray(parsed)) {
        parsed.forEach(function (item) {
          if (typeof item === 'string') {
            _this4.pushDuplicateEntry(entries, item, '');
          } else {
            _this4.collectDuplicateEntries(item, entries);
          }
        });
        return;
      }
      if (typeof parsed === 'string') {
        this.pushDuplicateEntry(entries, parsed, '');
        return;
      }
      this.collectDuplicateCategoryMap(parsed, entries);
    },
    pushDuplicateEntry: function pushDuplicateEntry(entries, category, attribute) {
      var cleanCategory = this.cleanDuplicateText(category);
      var cleanAttribute = this.cleanDuplicateText(attribute);
      if (!cleanCategory && !cleanAttribute) return;
      entries.push({
        category: cleanCategory,
        attribute: cleanAttribute
      });
    },
    pickFirstText: function pickFirstText(source, keys) {
      if (!source || _typeof(source) !== 'object' || Array.isArray(source)) return '';
      var _iterator = _createForOfIteratorHelper(keys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          if (!Object.prototype.hasOwnProperty.call(source, key)) continue;
          var direct = this.cleanDuplicateText(source[key]);
          if (direct) return direct;
          var nested = this.pickFirstText(source[key], keys);
          if (nested) return nested;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return '';
    },
    cleanDuplicateText: function cleanDuplicateText(value) {
      if (value === null || value === undefined) return '';
      if (_typeof(value) === 'object') return '';
      var text = String(value).trim();
      return text === '[object Object]' ? '' : text;
    },
    parseMaybeJson: function parseMaybeJson(value) {
      if (typeof value !== 'string') return value;
      var text = value.trim();
      if (!text || !/^[\[{]/.test(text)) return value;
      try {
        return JSON.parse(text);
      } catch (e) {
        return value;
      }
    },
    retryableStepNames: function retryableStepNames(exec) {
      var stepsInOrder = exec && exec.steps || [];

      // Solo habilitar reintento cuando hay un fallo real; nunca durante ejecución
      // en proceso (pending / in_progress). Si no hay pasos fallidos, no se ofrece retry.
      var hasActionableSteps = (exec && exec.retryable_steps || []).length > 0 || (exec && exec.continuable_steps || []).length > 0;
      if (!hasActionableSteps) return [];
      var skipBlocklist = this.isAdmin;
      var allRetryable = new Set([].concat(_toConsumableArray(exec && exec.retryable_steps || []), _toConsumableArray(exec && exec.continuable_steps || [])).filter(function (stepName) {
        return stepName && (skipBlocklist || !NON_RETRYABLE_STATUS_STEPS.includes(stepName));
      }));

      // Excepción: validate_attribute_table falla → el usuario debe reintentar
      // bq_dts_table primero (datos potencialmente corruptos en origen), luego
      // create_attribute_table, y solo al final validate_attribute_table.
      // Se usan timestamps para saber qué paso upstream ya fue reintentado
      // después del fallo.
      if (allRetryable.has('validate_attribute_table')) {
        var validateStep = stepsInOrder.find(function (s) {
          return s.step === 'validate_attribute_table';
        });
        var bqDtsStep = stepsInOrder.find(function (s) {
          return s.step === 'bq_dts_table';
        });
        var createAttrStep = stepsInOrder.find(function (s) {
          return s.step === 'create_attribute_table';
        });
        var validateTs = validateStep && validateStep.timestamp ? new Date(validateStep.timestamp) : null;
        var bqDtsTs = bqDtsStep && bqDtsStep.status === 'success' && bqDtsStep.timestamp ? new Date(bqDtsStep.timestamp) : null;
        var createAttrTs = createAttrStep && createAttrStep.status === 'success' && createAttrStep.timestamp ? new Date(createAttrStep.timestamp) : null;
        var bqDtsAfterFailure = bqDtsTs && validateTs && bqDtsTs > validateTs;
        var createAttrAfterBqDts = createAttrTs && bqDtsTs && createAttrTs > bqDtsTs;
        if (!bqDtsAfterFailure) {
          // Paso 3 no fue reintentado aún tras el fallo → habilitar paso 3
          allRetryable.delete('validate_attribute_table');
          allRetryable.add('bq_dts_table');
        } else if (!createAttrAfterBqDts) {
          // Paso 3 ya se reintentó; paso 4 no fue re-ejecutado tras eso → habilitar paso 4
          allRetryable.delete('validate_attribute_table');
          allRetryable.add('create_attribute_table');
        }
        // Si ambos upstream son más recientes que el fallo → habilitar paso 5 normalmente
      }

      // Progresivo: habilitar solo el primer paso retryable en orden de ejecución
      var firstRetryable = stepsInOrder.find(function (s) {
        return allRetryable.has(s.step);
      });
      return firstRetryable ? [firstRetryable.step] : [];
    },
    canRetryStep: function canRetryStep(exec, step) {
      if (!this.isIntercorpAdminUser) return false;
      if (!step || !exec) return false;
      return this.retryableStepNames(exec).includes(step.step);
    },
    hasRetryableSteps: function hasRetryableSteps(exec) {
      return this.retryableStepNames(exec).length > 0;
    },
    pendingCount: function pendingCount(exec) {
      return this.retryableStepNames(exec).length;
    },
    firstRetryableStepNumber: function firstRetryableStepNumber(exec) {
      var retryableNames = this.retryableStepNames(exec);
      var idx = (exec.steps || []).findIndex(function (s) {
        return retryableNames.includes(s.step);
      });
      return idx >= 0 ? idx + 1 : null;
    },
    retryStep: function () {
      var _retryStep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(exec, stepName) {
        var response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.retryingExec = exec.execution_id;
              this.retryingStep = stepName;
              _context2.p = 1;
              _context2.n = 2;
              return UseCasesService.retryPipelineStep(this.automationId, stepName);
            case 2:
              response = _context2.v;
              if (response && response.success) {
                tasks.toast.success(this.$t('create_attribute.activity_timeline.retry_success'));
              } else {
                tasks.toast.error(this.$t('create_attribute.activity_timeline.retry_error'));
              }
              this.refresh();
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              tasks.toast.error(this.$t('create_attribute.activity_timeline.retry_error'));
            case 4:
              _context2.p = 4;
              this.retryingExec = null;
              this.retryingStep = null;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function retryStep(_x, _x2) {
        return _retryStep.apply(this, arguments);
      }
      return retryStep;
    }(),
    retryAllForExec: function () {
      var _retryAllForExec = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(exec) {
        var retryableSteps, stepsToRun, failedAt, _iterator2, _step2, s, response, _t3, _t4;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.bulkRetryActive = true;
              this.retryingExec = exec.execution_id;
              _context3.p = 1;
              retryableSteps = this.retryableStepNames(exec);
              stepsToRun = (exec.steps || []).filter(function (s) {
                return retryableSteps.includes(s.step);
              }).map(function (s) {
                return s.step;
              });
              failedAt = null;
              _iterator2 = _createForOfIteratorHelper(stepsToRun);
              _context3.p = 2;
              _iterator2.s();
            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context3.n = 6;
                break;
              }
              s = _step2.value;
              this.retryingStep = s;
              // eslint-disable-next-line no-await-in-loop
              _context3.n = 4;
              return UseCasesService.retryPipelineStep(this.automationId, s);
            case 4:
              response = _context3.v;
              if (!(!response || !response.success)) {
                _context3.n = 5;
                break;
              }
              failedAt = s;
              return _context3.a(3, 6);
            case 5:
              _context3.n = 3;
              break;
            case 6:
              _context3.n = 8;
              break;
            case 7:
              _context3.p = 7;
              _t3 = _context3.v;
              _iterator2.e(_t3);
            case 8:
              _context3.p = 8;
              _iterator2.f();
              return _context3.f(8);
            case 9:
              if (failedAt) {
                tasks.toast.error(this.$t('create_attribute.activity_timeline.retry_error'));
              } else {
                tasks.toast.success(this.$t('create_attribute.activity_timeline.retry_success'));
              }
              this.refresh();
              _context3.n = 11;
              break;
            case 10:
              _context3.p = 10;
              _t4 = _context3.v;
              tasks.toast.error(this.$t('create_attribute.activity_timeline.retry_error'));
            case 11:
              _context3.p = 11;
              this.bulkRetryActive = false;
              this.retryingExec = null;
              this.retryingStep = null;
              return _context3.f(11);
            case 12:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 7, 8, 9], [1, 10, 11, 12]]);
      }));
      function retryAllForExec(_x3) {
        return _retryAllForExec.apply(this, arguments);
      }
      return retryAllForExec;
    }(),
    execTypeLabel: function execTypeLabel(type) {
      return this.$t("create_attribute.activity_timeline.types.".concat(type || 'creation'));
    },
    execTypeColor: function execTypeColor(type) {
      var map = {
        creation: 'primary',
        edit_script: 'deep-purple',
        load_months: 'teal'
      };
      return map[type] || 'grey';
    },
    execTypeIcon: function execTypeIcon(type) {
      var map = {
        creation: 'mdi-rocket-launch',
        edit_script: 'mdi-script-text-outline',
        load_months: 'mdi-calendar-plus'
      };
      return map[type] || 'mdi-circle-outline';
    },
    stepColor: function stepColor(status) {
      var map = {
        success: 'success',
        failed: 'error',
        skipped: 'warning',
        in_progress: 'info',
        pending: 'grey'
      };
      return map[status] || 'grey';
    },
    stepIcon: function stepIcon(status) {
      var map = {
        success: 'mdi-check-circle',
        failed: 'mdi-alert-circle',
        skipped: 'mdi-skip-next-circle',
        in_progress: 'mdi-progress-clock',
        pending: 'mdi-circle-outline'
      };
      return map[status] || 'mdi-circle-outline';
    },
    stepLabel: function stepLabel(stepName) {
      var key = "create_attribute.activity_timeline.steps.".concat(stepName);
      return this.$t(key);
    },
    awsStateColor: function awsStateColor(awsState) {
      if (!awsState) return 'grey';
      if (awsState.endsWith('_FAILED')) return 'error';
      if (awsState === 'TABLE_CREATED' || awsState === 'ATHENA_QUERY_COMPLETED') return 'success';
      return 'info';
    },
    awsStateIcon: function awsStateIcon(awsState) {
      if (!awsState) return 'mdi-circle-outline';
      if (awsState.endsWith('_FAILED')) return 'mdi-alert-circle';
      if (awsState === 'TABLE_CREATED' || awsState === 'ATHENA_QUERY_COMPLETED') return 'mdi-check-circle';
      return 'mdi-progress-clock';
    },
    formatTimestamp: function formatTimestamp(ts) {
      if (!ts) return '';
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      return new Date(ts).toLocaleDateString(undefined, options);
    }
  }
};